import Box from '@app/components/common/Box';
import Button from '@app/components/common/Button';
import Grid from '@app/components/common/Grid';
import Icon from '@app/components/common/Icon';
import {
  displayFlexColumnStyles,
  displayFlexRowStyles,
} from '@app/theme/commonStyles';
import { EMPLOYEE_SHIFT_INITIAL_STATE } from '@westondev/tableturn-core';
import { DateTime } from 'luxon';
import { useContext } from 'react';
import { WithTranslation } from 'react-i18next';
import { EmployeesScreenContext } from '../EmployeesContext';
import Amounts from './Amounts';
import ShiftDetails from './ShiftDetails';
import { EmployeeDetailsStyles } from './styles';

const EmployeeDetails = ({ t }: WithTranslation) => {
  const { setShift, user } = useContext(EmployeesScreenContext);

  return (
    <Box csx={EmployeeDetailsStyles}>
      <Grid csx={{ height: '100%', overflow: 'hidden' }} columnGap={20}>
        <Grid.Item mb={5} csx={{ heigh: '100%', overflow: 'hidden' }}>
          <Amounts />
        </Grid.Item>
        <Grid.Item csx={{ height: '100%', overflow: 'hidden' }} mb={7}>
          <Box csx={[displayFlexColumnStyles]} className="card">
            <Box
              csx={[
                displayFlexRowStyles,
                { justifyContent: 'flex-end', padding: 5 },
              ]}>
              <Button
                icon={<Icon name="MdAdd" />}
                variant="primary"
                csx={{ height: 40 }}
                onClick={() => {
                  const shiftDate = DateTime.now().toISO();

                  setShift({
                    ...EMPLOYEE_SHIFT_INITIAL_STATE,
                    organizationUserId: user?.orgUserId || 0,
                    startShift: shiftDate,
                    endShift: shiftDate,
                  });
                }}>
                {t(
                  'managementModule.employeesScreen.employeeDetailsTable.addShift',
                )}
              </Button>
            </Box>
            <Box csx={{ flexGrow: 1, flexShrink: 1, overflow: 'hidden' }}>
              <ShiftDetails />
            </Box>
          </Box>
        </Grid.Item>
      </Grid>
    </Box>
  );
};

export default EmployeeDetails;
